export default "__VITE_ASSET__BjiOaKnR__"